// TRACKING DETAILS
export const TRACKING_DETAILS_COOKIE = 'gbi_tracking_details';
export const TRACKING_DETAILS_ATTRIBUTION_WINDOW_DAYS = 90;
